import ConfirmProvider from './ConfirmProvider'

export default ConfirmProvider
